import secureLocalStorage from 'react-secure-storage';
import Login from '../login/Login';
import { ProtectedProps } from '../../interfaces/props/ProtectedProps';
import { StoredFields } from '../../enums/StoredFields';
import ValidateHelper from '../../helpers/validate.helper';
import { OneLoginUser } from '../../interfaces/OneLoginUser';

const Protected = ({ element }: ProtectedProps) => {
  const isLoggedIn = () => {
    const user: OneLoginUser = Object(secureLocalStorage.getItem(StoredFields.ONE_LOGIN_USER));

    return ValidateHelper.isMail(user.email ?? '');
  };

  return isLoggedIn() ? element : <Login />;
};

export default Protected;
